export default function ResultTable({children, style = {}, ...props}) {
    const fontFamily = window.location.pathname.includes('/app/report') ? 'Calibri' : 'Segoe UI'
    const fontSize = window.location.pathname.includes('/app/report') ? '11pt' : '9pt'

    return (
        <table {...props} style={{display: 'block', fontFamily: fontFamily, fontSize: fontSize, ...style}}>
            {children}
        </table>
    )
}